import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Localization from "../../localization";
import Item from "./item";
import { getUrl } from "../../utils/helper";

class Library extends Component {
    render() {
        const { data, locale } = this.props;

        return (
            <div className="bg-grey pt-200 xl:pt-250 px-16 xl:px-50">
                <div>
                    <h1 className="font-judge font-bold uppercase text-center text-50 xl:text-100 text-blue">
                        {Localization[locale].library.title}
                    </h1>
                </div>
                <div className="flex my-80">
                    <div className="w-4/12 mr-16" />
                    <div className="flex w-8/12">
                        <p className="font-judge font-bold uppercase flex-1 text-30 text-blue">
                            {Localization[locale].library.year}
                        </p>
                        <p className="w-7/12">
                            {Localization[locale].library.description}
                        </p>
                    </div>
                </div>
                <div className="pb-60">
                    <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-32">
                        {data.map((item) => (
                            <Item item={item} />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    data: [
        {
            title: "sinfonia nº9 em re menor op.125",
            slug: "temporada-2020-2021",
            author: "Diogo Almeida",
            year: "2018",
            edition: "Edição 1",
            image: "/img/img_b_1.jpg",
            link: "",
        },
        {
            title: "guest lectures port academy",
            slug: "temporada-2020-2021",
            author: "Ryue Nishizawa e Smijan Radic",
            year: "2017",
            edition: "Edição 1",
            image: "/img/img_b_2.jpg",
            link: "",
        },
        {
            title: "casa do design matosinhos",
            slug: "temporada-2020-2021",
            author: "Francisco Providência",
            year: "2016",
            edition: "Edição 1",
            image: "/img/img_b_3.jpg",
            link: "",
        },
        {
            title: "sinfonia nº9 em re menor op.125",
            slug: "temporada-2020-2021",
            author: "Diogo Almeida",
            year: "2018",
            edition: "Edição 1",
            image: "/img/img_b_2.jpg",
            link: "",
        },
        {
            title: "guest lectures port academy",
            slug: "temporada-2020-2021",
            author: "Ryue Nishizawa e Smijan Radic",
            year: "2017",
            edition: "Edição 1",
            image: "/img/img_b_3.jpg",
            link: "",
        },
        {
            title: "casa do design matosinhos",
            slug: "temporada-2020-2021",
            author: "Francisco Providência",
            year: "2016",
            edition: "Edição 1",
            image: "/img/img_b_1.jpg",
            link: "",
        },
    ],
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Library);
